/** Auto-generated by scripts/sync-err-catalogue.mjs — 325 codes */
export const ERR_CATALOGUE_CODES: readonly string[] = [
  "ERR-APRV-3001",
  "ERR-APRV-3002",
  "ERR-APRV-3003",
  "ERR-APRV-3004",
  "ERR-APRV-6001",
  "ERR-AUTH-0001",
  "ERR-AUTH-0002",
  "ERR-AUTH-0003",
  "ERR-AUTH-0010",
  "ERR-AUTH-0011",
  "ERR-AUTH-0012",
  "ERR-AUTH-0013",
  "ERR-AUTH-0014",
  "ERR-AUTH-0021",
  "ERR-AUTH-0022",
  "ERR-AUTH-0023",
  "ERR-AUTH-0031",
  "ERR-AUTH-0032",
  "ERR-AUTH-0033",
  "ERR-AUTH-0034",
  "ERR-AUTH-0035",
  "ERR-AUTH-0036",
  "ERR-AUTH-0041",
  "ERR-AUTH-0042",
  "ERR-AUTH-0043",
  "ERR-AUTH-0051",
  "ERR-AUTH-0061",
  "ERR-AUTH-0062",
  "ERR-AUTH-0063",
  "ERR-AUTH-0064",
  "ERR-AUTH-0071",
  "ERR-AUTH-0072",
  "ERR-AUTH-0073",
  "ERR-BRCH-1001",
  "ERR-BRCH-1003",
  "ERR-BRCH-1004",
  "ERR-BRCH-1005",
  "ERR-BRCH-1006",
  "ERR-BRCH-2002",
  "ERR-BRCH-2003",
  "ERR-BRCH-3001",
  "ERR-BRCH-3002",
  "ERR-BRCH-3003",
  "ERR-BRCH-4001",
  "ERR-BRCH-6001",
  "ERR-BRCH-6002",
  "ERR-BRCH-6003",
  "ERR-BSKT-1001",
  "ERR-BSKT-1002",
  "ERR-BSKT-1003",
  "ERR-BSKT-2002",
  "ERR-BSKT-2003",
  "ERR-BSKT-3001",
  "ERR-BSKT-3002",
  "ERR-BSKT-6001",
  "ERR-BSKT-6002",
  "ERR-CORP-1001",
  "ERR-CORP-1002",
  "ERR-CORP-1003",
  "ERR-CORP-2002",
  "ERR-CORP-2003",
  "ERR-CORP-2004",
  "ERR-CORP-2006",
  "ERR-CORP-3001",
  "ERR-CORP-6001",
  "ERR-CORP-6002",
  "ERR-CORP-6003",
  "ERR-CTLG-1001",
  "ERR-CTLG-1002",
  "ERR-CTLG-2001",
  "ERR-CTLG-2002",
  "ERR-CTLG-2003",
  "ERR-CTLG-2004",
  "ERR-CTLG-2005",
  "ERR-CTLG-2006",
  "ERR-CTLG-2007",
  "ERR-CTLG-3001",
  "ERR-CTLG-3002",
  "ERR-CTLG-3003",
  "ERR-CTLG-3004",
  "ERR-CTLG-3005",
  "ERR-CTLG-3006",
  "ERR-CTLG-3007",
  "ERR-CTLG-3008",
  "ERR-CTLG-4001",
  "ERR-CUST-2001",
  "ERR-CUST-2002",
  "ERR-CUST-2003",
  "ERR-CUST-3001",
  "ERR-CUST-4001",
  "ERR-CUST-6001",
  "ERR-DLVR-3001",
  "ERR-DLVR-3002",
  "ERR-DLVR-3003",
  "ERR-DLVR-3004",
  "ERR-DLVR-3005",
  "ERR-DLVR-3007",
  "ERR-DLVR-3008",
  "ERR-DLVR-5001",
  "ERR-DLVR-6001",
  "ERR-DLVR-9001",
  "ERR-FULF-1001",
  "ERR-FULF-1002",
  "ERR-FULF-1003",
  "ERR-FULF-2001",
  "ERR-FULF-3001",
  "ERR-FULF-3002",
  "ERR-FULF-3003",
  "ERR-FULF-3004",
  "ERR-FULF-3005",
  "ERR-FULF-3006",
  "ERR-FULF-3007",
  "ERR-FULF-3008",
  "ERR-FULF-6041",
  "ERR-IDNT-2001",
  "ERR-IDNT-3001",
  "ERR-IDNT-3002",
  "ERR-IDNT-3003",
  "ERR-IDNT-4001",
  "ERR-IDNT-4002",
  "ERR-IDNT-9001",
  "ERR-INVC-1001",
  "ERR-INVC-3001",
  "ERR-INVC-3002",
  "ERR-INVC-3003",
  "ERR-INVC-6001",
  "ERR-INVC-9001",
  "ERR-INVT-1001",
  "ERR-INVT-1003",
  "ERR-INVT-1004",
  "ERR-INVT-2001",
  "ERR-INVT-2002",
  "ERR-INVT-2003",
  "ERR-INVT-3001",
  "ERR-INVT-3002",
  "ERR-INVT-3003",
  "ERR-INVT-6001",
  "ERR-INVT-6002",
  "ERR-INVT-9001",
  "ERR-LDGR-3001",
  "ERR-LDGR-3002",
  "ERR-LDGR-3003",
  "ERR-LDGR-3004",
  "ERR-LDGR-4001",
  "ERR-LDGR-6001",
  "ERR-LDGR-9001",
  "ERR-MEDA-1061",
  "ERR-MEDA-1062",
  "ERR-MEDA-3001",
  "ERR-MEDA-3002",
  "ERR-MEDA-4001",
  "ERR-NOTF-1001",
  "ERR-NOTF-1002",
  "ERR-NOTF-3001",
  "ERR-NOTF-3002",
  "ERR-NOTF-3004",
  "ERR-NOTF-5001",
  "ERR-ORDR-2001",
  "ERR-ORDR-2006",
  "ERR-ORDR-3001",
  "ERR-ORDR-3002",
  "ERR-ORDR-3003",
  "ERR-ORDR-3004",
  "ERR-ORDR-3005",
  "ERR-ORDR-3007",
  "ERR-ORDR-3008",
  "ERR-ORDR-3009",
  "ERR-ORDR-3010",
  "ERR-ORDR-3011",
  "ERR-ORDR-3012",
  "ERR-ORDR-3013",
  "ERR-ORDR-3014",
  "ERR-ORDR-6001",
  "ERR-ORDR-9001",
  "ERR-PLAT-1001",
  "ERR-PLAT-1002",
  "ERR-PLAT-1003",
  "ERR-PLAT-2001",
  "ERR-PLAT-2002",
  "ERR-PLAT-2003",
  "ERR-PLAT-3001",
  "ERR-PLAT-3002",
  "ERR-PLAT-3003",
  "ERR-PLAT-5001",
  "ERR-PLAT-5002",
  "ERR-PLAT-5003",
  "ERR-PLAT-8001",
  "ERR-PLAT-8002",
  "ERR-PLAT-9001",
  "ERR-PRIC-1001",
  "ERR-PRIC-1002",
  "ERR-PRIC-4001",
  "ERR-PRIC-5001",
  "ERR-PRIC-6001",
  "ERR-PRIC-9001",
  "ERR-PRIC-9002",
  "ERR-PROM-1001",
  "ERR-PROM-1002",
  "ERR-PROM-1004",
  "ERR-PROM-1005",
  "ERR-PROM-2002",
  "ERR-PROM-2003",
  "ERR-PROM-2004",
  "ERR-PROM-4001",
  "ERR-PROM-4003",
  "ERR-PROM-6001",
  "ERR-PROM-6002",
  "ERR-PROM-6003",
  "ERR-PYMT-1001",
  "ERR-PYMT-1002",
  "ERR-PYMT-2001",
  "ERR-PYMT-3001",
  "ERR-PYMT-3002",
  "ERR-PYMT-3003",
  "ERR-PYMT-3004",
  "ERR-PYMT-3005",
  "ERR-PYMT-3006",
  "ERR-PYMT-3007",
  "ERR-PYMT-3008",
  "ERR-PYMT-5001",
  "ERR-PYMT-5002",
  "ERR-PYMT-6001",
  "ERR-PYOT-1001",
  "ERR-PYOT-2001",
  "ERR-PYOT-2002",
  "ERR-PYOT-3001",
  "ERR-PYOT-3002",
  "ERR-PYOT-3003",
  "ERR-PYOT-3004",
  "ERR-PYOT-3005",
  "ERR-PYOT-3006",
  "ERR-PYOT-6001",
  "ERR-PYOT-6002",
  "ERR-RATE-7001",
  "ERR-RATE-7002",
  "ERR-RATE-7003",
  "ERR-RATE-7004",
  "ERR-RATE-7005",
  "ERR-RFND-1001",
  "ERR-RFND-3001",
  "ERR-RFND-3002",
  "ERR-RFND-3003",
  "ERR-RFND-3004",
  "ERR-RFND-3005",
  "ERR-RFND-3006",
  "ERR-RFND-3011",
  "ERR-RFND-3012",
  "ERR-RFND-3013",
  "ERR-RFND-5001",
  "ERR-RFND-6001",
  "ERR-RISK-3001",
  "ERR-RISK-3002",
  "ERR-RISK-5001",
  "ERR-RISK-6001",
  "ERR-RVWS-1001",
  "ERR-RVWS-1002",
  "ERR-RVWS-2001",
  "ERR-RVWS-2002",
  "ERR-RVWS-2003",
  "ERR-RVWS-3001",
  "ERR-RVWS-3002",
  "ERR-RVWS-3003",
  "ERR-RVWS-6001",
  "ERR-SUPP-1002",
  "ERR-SUPP-2001",
  "ERR-SUPP-3001",
  "ERR-SUPP-3002",
  "ERR-SUPP-3004",
  "ERR-SUPP-3005",
  "ERR-SUPP-3006",
  "ERR-SUPP-4001",
  "ERR-TAXX-1001",
  "ERR-TAXX-1002",
  "ERR-TAXX-3001",
  "ERR-TAXX-4001",
  "ERR-TAXX-9001",
  "ERR-TNNT-1001",
  "ERR-TNNT-1002",
  "ERR-TNNT-1011",
  "ERR-TNNT-1012",
  "ERR-TNNT-1013",
  "ERR-TNNT-1014",
  "ERR-TNNT-1015",
  "ERR-TNNT-1016",
  "ERR-TNNT-2001",
  "ERR-TNNT-3001",
  "ERR-TNNT-3002",
  "ERR-TNNT-3003",
  "ERR-TNNT-3011",
  "ERR-TNNT-4001",
  "ERR-TNNT-6001",
  "ERR-VALD-1000",
  "ERR-VALD-1001",
  "ERR-VALD-1002",
  "ERR-VALD-1003",
  "ERR-VALD-1004",
  "ERR-VALD-1005",
  "ERR-VALD-1006",
  "ERR-VALD-1010",
  "ERR-VALD-1011",
  "ERR-VALD-1012",
  "ERR-VALD-1013",
  "ERR-VALD-1020",
  "ERR-VALD-1022",
  "ERR-VALD-1023",
  "ERR-VALD-1025",
  "ERR-VALD-1032",
  "ERR-VALD-1033",
  "ERR-VALD-1041",
  "ERR-VALD-1042",
  "ERR-VALD-1051",
  "ERR-VALD-1070",
  "ERR-VALD-9001",
  "ERR-WBHK-1001",
  "ERR-WBHK-2001",
  "ERR-WBHK-3001",
  "ERR-WBHK-3002",
  "ERR-WBHK-3003",
  "ERR-WBHK-4001",
  "ERR-WLLT-3001",
  "ERR-WLLT-3002",
  "ERR-WLLT-6001",
  "ERR-WLLT-6002",
  "ERR-WLLT-6003",
  "ERR-WLLT-9001"
] as const;

export function defaultMessageForCode(code: string): string {
  return `An error occurred (${code}). Please try again.`;
}

export function buildErrorMessageMap(): Record<string, string> {
  return Object.fromEntries(ERR_CATALOGUE_CODES.map((c) => [c, defaultMessageForCode(c)]));
}
